import { createPortal } from 'react-dom'
import { PORT_COLORS } from '../constants'

interface PortDragPreviewProps {
  draggedPort: number
  mousePosition: { x: number; y: number }
}

export function PortDragPreview({ draggedPort, mousePosition }: PortDragPreviewProps) {
  const portColor = PORT_COLORS[(draggedPort - 1) % PORT_COLORS.length]

  const content = (
    <div
      className="fixed pointer-events-none z-[9999]"
      style={{
        left: `${mousePosition.x}px`,
        top: `${mousePosition.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div
        className="w-12 h-12 flex items-center justify-center rounded-md border-2 shadow-lg"
        style={{
          backgroundColor: `${portColor}40`,
          borderColor: portColor,
          boxShadow: `0 0 20px ${portColor}`
        }}
      >
        <span
          className="text-xs font-bold"
          style={{ color: portColor }}
        >
          {draggedPort}
        </span>
      </div>
      <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-center">
        <p className="text-xs font-medium text-foreground bg-card/90 backdrop-blur-sm px-2 py-1 rounded border whitespace-nowrap">
          Glisser vers un autre port
        </p>
      </div>
    </div>
  )

  if (typeof document === 'undefined') return null
  return createPortal(content, document.body)
}
